import { PageHeaderFilterControl, PageHeaderSelectFilterControl } from '@/types/model/pageHeaderBar';

const clamp = (value: string, maxLength: number): string => {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, Math.max(0, maxLength - 3))}...`;
};

const getSelectValuesText = <TValue extends string | number>(
  control: PageHeaderSelectFilterControl<TValue>
): string => {
  if (control.selectedText) {
    return control.selectedText;
  }

  const selectedValues = Array.isArray(control.value) ? control.value : [control.value];

  const labels = control.options
    .filter((option) => selectedValues.includes(option.value))
    .map((option) => option.label);

  return labels.length > 0 ? labels.join(', ') : 'None';
};

export const buildFilterSummary = <TValue extends string | number>(
  controls: PageHeaderFilterControl<TValue>[],
  maxLength: number = 120
): string => {
  const summaryParts = controls.map((control) => {
    if (control.type === 'toggle') {
      return `${control.label}: ${control.checked ? 'On' : 'Off'}`;
    }

    return `${control.label}: ${getSelectValuesText(control as PageHeaderSelectFilterControl<TValue>)}`;
  });

  if (summaryParts.length === 0) {
    return 'No filters';
  }

  return clamp(summaryParts.join(' | '), maxLength);
};
